module.exports = __webpack_public_path__ + "./assets/home_hero_image.jpg";